
export const PROJECT_ROUTE_LIST = ['projects'];
export const SETTING_ROUTE_LIST = ['/settings/members', '/settings/profile', '/settings/webhooks/list', '/settings/tokens'];
export const APPROVAL_ROUTE_LIST = ['/approvals/list', '/approvals/mine'];

export const TARGETING_ROUTE_LIST = ['targeting', 'traffic', 'analysis'];
export const TOGGLE_ROUTE_LIST = ['toggles'];
export const SEGMENT_ROUTE_LIST = ['segments'];